<template>
  <base-content-block :need-indent-content="false">
    <template #title>{{ $t('src/pages/coursesbinding.3562') }}</template>
    <template #content>
      <div :class="{ 'd-flex justify-content-between': isShowPinCode }">
        <section :class="{ 'col-7 card-part-border': isShowPinCode }" class="card-part">
          <course-pin-code v-if="isShowPinCode" :course-id="courseId"></course-pin-code>
          <course-pin-smartphone
            v-else-if="course"
            :smartphone="course.smartphone_data"
          ></course-pin-smartphone>
          <div class="row mt-3 mb-4">
            <div
              v-if="isNewCourse"
              :class="[
                { 'col-lg-6 col-md-6 col-12': !isShowPinCode },
                { 'col-lg-9 col-md-9 col-12': isShowPinCode }
              ]"
            >
              <base-checkbox name="checkbox-instruction" v-model="checkedInstruction"
                >{{ $t('src/pages/coursesbinding.1219')
                }}<a href="/files/instruction-12.01.20.pdf" target="_blank">{{
                  $t('src/pages/coursesbinding.9482')
                }}</a
                >{{ $t('src/pages/coursesbinding.5199')
                }}<a href="/files/memo-09.09.20.pdf" target="_blank">{{
                  $t('src/pages/coursesbinding.6872')
                }}</a
                >.
              </base-checkbox>
            </div>
          </div>
          <button type="button" @click="goToCourseEdit" class="btn btn-primary" :disabled="!isCanProceed">
            {{
              isNewCourse
                ? $t('src/pages/coursesbinding.finishCourseCreation')
                : $t('src/pages/coursesbinding.returnCourse')
            }}
          </button>
        </section>
        <section class="col-5 card-part" v-if="isShowPinCode">
          <h4>{{ $t('src/pages/coursesbinding.qr') }}</h4>
          <div class="mt-2 d-flex align-item-center justify-content-center">
            <qrcode :appApiKey="course.qr_code_link_token"></qrcode>
          </div>
        </section>
      </div>
    </template>
  </base-content-block>
</template>

<script>
import http from '@/modules/http.js'
import { contentTpl } from '@/mixins/content-tpl.js'
import { subscribeLinkMobile } from '@/mixins/subscribe-link-mobile.js'

export default {
  name: 'CoursesBinding',
  components: {
    CoursePinCode: () => import('@/components/CoursePinCode.vue'),
    CoursePinSmartphone: () => import('@/components/CoursePinSmartphone.vue'),
    BaseCheckbox: () => import('@/base/BaseCheckbox.vue'),
    Qrcode: () => import('@/components/Qrcode.vue')
  },
  mixins: [contentTpl, subscribeLinkMobile],
  data: () => ({
    courseId: null,
    course: null,
    appApiKey: null,
    oldAppApiKey: null,
    checkedInstruction: false,
    isBoundAgain: null,
    isEnteredCode: false
  }),
  computed: {
    isAppBound() {
      return Boolean(this.appApiKey !== this.oldAppApiKey)
    },
    isAppBoundAgain() {
      return this.isBoundAgain && this.appApiKey == this.oldAppApiKey
    },
    isNewCourse() {
      return this.$route.name === 'new-course-binding'
    },
    isCanProceed() {
      if (this.isNewCourse) {
        return this.isAppBound && this.checkedInstruction
      }
      return this.isAppBound
    },
    isPlan() {
      if (this.courseId && this.course.status === 1) return true
      else return false
    },
    isShowPinCode() {
      return Boolean(this.course && (this.isPlan || this.isAppBoundAgain))
    }
  },
  mounted() {
    this.canSubscribe = true
    this.courseId = parseInt(this.$route.params.id)
    this.isBoundAgain = this.$route.params.isBoundAgain
    this.oldAppApiKey = this.$route.params.oldAppApiKey
    this.getCourseStatus()
  },
  methods: {
    getCourseStatus() {
      http
        .get('/courses/' + this.courseId)
        .then(response => response.data)
        .then(course => {
          this.appApiKey = course.app_api_key
          this.course = course
        })
        .catch(error => console.log(error))
    },
    goToCourseEdit() {
      this.$router.push({ name: 'course-edit', params: { id: this.courseId } })
    },
    setCourseBindingInfo() {
      http
        .get('/courses/' + this.courseId)
        .then(response => response.data)
        .then(course => {
          this.appApiKey = course.app_api_key
          this.course = course
          this.isEnteredCode = true
        })
        .catch(error => console.log(error))
    }
  }
}
</script>
